export type { NewCoursesBannerProps } from './new-courses-banner';
export { NewCoursesBanner } from './new-courses-banner';
